import { render, staticRenderFns } from "./PropertyExamine1.vue?vue&type=template&id=70b1b29e"
import script from "./PropertyExamine1.vue?vue&type=script&lang=js"
export * from "./PropertyExamine1.vue?vue&type=script&lang=js"
import style0 from "./PropertyExamine1.vue?vue&type=style&index=0&id=70b1b29e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports